








import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import SimpleText from "front-component/components/SimpleText.vue";

interface Request {
    topic: {
        title: string;
    };
    subtopic: {
        title: string;
    };
}

@Component({ components: { SimpleText } })
export default class Topic extends Vue {
    @Prop() public request!: Request;

    public static getNeededFields(): string[] {
        return [
            "request.topic.title",
            "request.subtopic.title",
            "request.children.topic.title",
            "request.children.subtopic.title",
        ];
    }
}
